import React from "react";
import { Link } from "react-router-dom";

export const Navbar = ({ onCta }) => {
  const links = [
    { label: "How it works", href: "#how" },
    { label: "Live demo", href: "#demo" },
    { label: "Pricing", href: "#pricing" },
  ];
  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 bg-paper/85 backdrop-blur-md border-b border-border"
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5" data-testid="brand-logo">
          <img src="/kashbaaki-logo.png" alt="KashBaaki" className="h-8 w-auto object-contain" />
          <span className="hidden sm:inline font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground border-l border-border pl-2.5">
            MSMED Act · §16
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="text-sm text-muted-foreground hover:text-ink transition-colors duration-150"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-5">
          <Link
            to="/login"
            data-testid="nav-signin"
            className="hidden sm:inline text-sm text-muted-foreground hover:text-ink transition-colors duration-150"
          >
            Sign in
          </Link>
          <span
            data-testid="nav-kashsam-badge"
            className="hidden lg:flex items-center gap-2 text-[10px] font-mono uppercase tracking-[0.14em] text-muted-foreground"
          >
            A
            <img src="/kashsam-logo.png" alt="Kashsam Data Solutions" className="h-4 w-auto object-contain" />
            product
          </span>
          <button
            data-testid="nav-cta-btn"
            onClick={onCta}
            className="bg-signal text-white text-sm font-medium px-4 py-2 hover:bg-signal-dark hover:-translate-y-[1px] transition-transform duration-150"
          >
            Join waitlist
          </button>
        </div>
      </div>
    </header>
  );
};
